import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Coaches from '@/views/team/tabs/Coaches.vue';

export const teamCoachesRoute = {
  path: 'coaches',
  name: 'teamCoaches',
  component: Coaches,
  meta: { title: 'titles.team.coaches' },
  beforeEnter: (to: any, from: any, next: any) =>
    store
      .dispatch('team/coach/list', { coachedTeamId: tryParseInt(to.params.teamId) })
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: 'messages.team.coach.listError' }))
};
